import { getRequest, postRequest, postRequestWithToken } from '.';
import Toast from '../utils/toast';
import { baseUrl } from '../constants/constants';

const SignIn = async payload => {
  try {
    const signInPath = `/login`;
    const response = await postRequest(signInPath, payload);
    return response;
  } catch (error) {
    Toast('error', error?.response?.data?.message);
    // Return a proper error response structure
    return {
      data: { success: false, msg: error?.response?.data?.message || 'Login failed' },
      status: error?.response?.status || 500
    };
  }
};

const Register = async payload => {
  try {
    const registerPath = `/register`;
    const response = await postRequest(registerPath, payload);
    return response;
  } catch (error) {
    // Handle network/CORS errors
    if (error.code === 'ERR_NETWORK' || error.message.includes('Network Error')) {
      Toast('error', 'Network error. Please check if the backend server is running.');
      return {
        data: { success: false, msg: 'Network error. Please check if the backend server is running.' },
        status: 0
      };
    }
    
    // Handle other errors
    const errorMessage = error?.response?.data?.message || error?.response?.data?.msg || 'Registration failed';
    Toast('error', errorMessage);
    return {
      data: { success: false, msg: errorMessage },
      status: error?.response?.status || 500
    };
  }
};

const ForgotPassword = async payload => {
  try {
    const forgotPasswordPath = `/forgot_password`;
    return await postRequest(forgotPasswordPath, payload);
  } catch (error) {
    Toast('error', error?.response?.data?.message);
  }
};

const ChangePassword = async payload => {
  try {
    const changePasswordPath = `/change_password`;
    return await postRequestWithToken(changePasswordPath, payload);
  } catch (error) {
    Toast('error', error?.response?.data?.message);
  }
};

const GetUser = async () => {
  try {
    const userPath = `/offers `;
    return await getRequest(userPath);
  } catch (error) {
    Toast('error', error?.response?.data?.message);
  }
};


export const authService = {
  SignIn,
  Register,
  ForgotPassword,
  ChangePassword,
  GetUser
};
